import { ExpandLess, ExpandMore } from "@mui/icons-material";
import {
  Collapse,
  FormControl,
  InputLabel,
  ListItem,
  Select,
  Tooltip,
  Zoom,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import moment from "moment";
import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import IconText from "components/IconText";
import TextIcon from "./TextIcon";

import { data } from "utils/dummy";
import { useBoundStore } from "store/store";
import i18n from "i18n/i18n";
import { v4 as uuidv4 } from "uuid";

import { ReactComponent as TickSvg } from "assets/Svgs/tick.svg";
import { ReactComponent as RedRanchSvg } from "assets/Svgs/redRanch.svg";
import { ReactComponent as GreenRanchSvg } from "assets/Svgs/GreenRanch.svg";
import { ReactComponent as GeplantCalSvg } from "assets/Svgs/GeplantCal.svg";

function NewCalender(props: any) {
  const lang: any = useBoundStore((state) => state.lang);

  useEffect(() => {
    setmap(props.map);
  }, [props.map]);

  const subscribedEquipmentpools: any = useBoundStore(
    (state) => state.subscribedEquipmentpools
  );

  const subscribedAreas: any = useBoundStore((state) => state.subscribedAreas);

  const subscribedSites: any = useBoundStore((state) => state.subscribedSites);

  const getAllNotifications: any = useBoundStore(
    (state) => state.getAllNotifications
  );

  const monthsByName: any[] =
    lang === "de"
      ? [
          "Januar",
          "Februar",
          "März",
          "April",
          "Mai",
          "Juni",
          "Juli",
          "August",
          "September",
          "Oktober",
          "November",
          "Dezember",
        ]
      : [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];

  const [currMonth, setCurrMonth] = React.useState<any>("");
  const [monthsByID, setMonthsById] = React.useState<any[]>([]);
  const [title, settitle] = useState("");
  const [subtitle, setsubtitle] = useState(i18n(lang).all);
  const [stopCalendar, setstopCalendar] = useState(3);
  const [startCalendar, setstartCalendar] = useState(1);
  // const [nexMonBtnDisabled, setnexMonBtnDisabled] = useState(false);
  // const [prevMonBtnDisabled, setprevMonBtnDisabled] = useState(false);
  const [map, setmap] = useState();
  var currYear = moment(new Date()).format("YYYY");
  const firstYear = moment(new Date()).add(2, "months").format("YYYY");
  const secondYear = moment(new Date()).add(5, "months").format("YYYY");
  const thirdYear = moment(new Date()).add(11, "months").format("YYYY");
  const threeMonths = parseInt(currMonth) + 2;
  const sixMonths = parseInt(currMonth) + 5;
  const twelveMonths = parseInt(currMonth) + 11;
  var three = 0;
  var six = 0;
  var twelve = 0;
  threeMonths > 12 ? (three = threeMonths - 12) : (three = threeMonths);
  sixMonths > 12 ? (six = sixMonths - 12) : (six = sixMonths);
  twelveMonths > 12 ? (twelve = twelveMonths - 12) : (twelve = twelveMonths);

  const [boxCollapsed, setBoxCollapsed] = useState(-1);
  const [state, setState] = React.useState({
    wrek: "",
    period: "",
    name: "hai",
  });

  let calenderTimeSpan = 3; //in years

  function isEmpty(obj: any) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) return false;
    }
    return true;
  }

  const handleChange = (event: { target: { name: any; value: any } }) => {
    const name = event.target.name;
    setState({
      ...state,
      [name]: event.target.value,
    });
  };

  function handleNotificationClick(item: {
    nodeid: string;
    haschatroom: { chatroom: { nodeid: string } }[];
  }) {
    const notificationnodeid = item.nodeid;

    localStorage.setItem("notification-nodeid", item.nodeid);
    localStorage.setItem(
      "chatroomnodeid",
      item.haschatroom?.[0]?.chatroom.nodeid
    );
  }

  function checkOverDue(startingfrom: any, ts: any) {
    if (ts > Date.now()) {
      return false;
    } else {
      return true;
    }
  }

  interface RenderTDProps {
    lane: any;
    id: any;
    mon: any;
    year: any;
    showIcon: any;
    mainIndex: any;
  }

  function isTodayOrFutureFnc(inputTimestamp: any) {
    const inputDate = new Date(inputTimestamp);
    const now = new Date();

    // Start of today
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);

    return inputDate >= startOfToday;
  }

  function RenderTileStyle(
    hasNotification: any,
    isClosed: any,
    isTodayOrFuture: any
  ) {
    let icon = hasNotification ? (
      isClosed ? (
        <TickSvg />
      ) : !isTodayOrFuture ? (
        <RedRanchSvg />
      ) : (
        <GreenRanchSvg />
      )
    ) : (
      <GeplantCalSvg />
    );

    let iconText = hasNotification
      ? isClosed
        ? "erledigt"
        : !isClosed && !isTodayOrFuture
        ? "Überfallig"
        : !isClosed && isTodayOrFuture
        ? "Durchführbar"
        : ""
      : "Geplant";

    let textColor = hasNotification
      ? isClosed
        ? "#0000003F"
        : !isClosed && !isTodayOrFuture
        ? "#FF3D00"
        : !isClosed && isTodayOrFuture
        ? "#6FA03B"
        : "#0000003F"
      : "#0000003F";

    let border = hasNotification
      ? isClosed
        ? "1px solid #0000003F"
        : !isClosed && !isTodayOrFuture
        ? "1.9px solid  #FF3D00"
        : !isClosed && isTodayOrFuture
        ? "1.9px solid #6FA03B"
        : "1px solid #0000003F"
      : "1px solid #0000003F";

    return {
      icon,
      iconText,
      textColor,
      border,
    };
  }

  function RenderTD(props: any) {
    const { lane, id, mon, year, showIcon, mainIndex } = props;

    let done = false;

    let month = moment(lane.task.startingfrom).format("MM");
    month = +month > 9 ? month : month[1];

    let isWeeklyNotification = lane.task.repetitioninterval === "1w";

    // ui use cases for below code :

    // 1. Detailed view ( checking two conditions (if maintenance task has notification or not) )
    // 2. Minimized View ( checking two conditions (if maintenance task notification or not) )

    return (
      <>
        {boxCollapsed === mainIndex ? (
          <td
            id={id}
            className={id % 2 == 0 ? "brdr-none" : "has-border"}
            style={{
              height: id === 0 ? "136px" : "77px",
              display: "flex",
              alignItems: "center",
              width: "100%",
            }}
          >
            {lane.occurance.map((occurance: any, k: any) => {
              let hasNotification = occurance?.notification !== undefined;

              let isClosed =
                hasNotification && occurance?.notification?.status === 2;
              let isTodayOrFuture =
                hasNotification &&
                isTodayOrFutureFnc(occurance?.notification?.dueuntil);

              let { icon, iconText, textColor, border } = RenderTileStyle(
                hasNotification,
                isClosed,
                isTodayOrFuture
              );

              return (
                occurance.occMonth == mon &&
                year == occurance.occYear &&
                (occurance?.notification?.nodeid != undefined ? (
                  <Fragment key={k}>
                    <Link
                      to="/notification-details"
                      state={{
                        nodeid: occurance.notification.nodeid,
                        equipmentNodeId: occurance.notification.equipmentnodeid,
                        from: "maintenance_dashboard",
                      }}
                      onClick={() =>
                        handleNotificationClick(occurance.notification)
                      }
                    >
                      <div
                        key={k}
                        className="bxShadow newCalenderPill"
                        style={{
                          width:
                            showIcon && !isWeeklyNotification
                              ? "170px"
                              : "fit-content",
                          height: "fit-content",
                          marginLeft: "2px",
                          marginTop:
                            id === 0 && boxCollapsed == mainIndex
                              ? "56px"
                              : "0px",

                          border: border,
                        }}
                      >
                        <div
                          className="header"
                          style={{
                            textDecorationLine:
                              occurance.notification.status === 2
                                ? "line-through"
                                : "",
                          }}
                        >
                          {moment(occurance.occTS).format(
                            isWeeklyNotification ? "DD:MM" : "DD.MM.YYYY"
                          )}
                        </div>
                        {showIcon && !isWeeklyNotification && (
                          <TextIcon
                            svg={icon}
                            text={iconText}
                            textColor={textColor}
                          />
                        )}{" "}
                      </div>
                    </Link>
                  </Fragment>
                ) : (
                  <div
                    key={k}
                    className="bxShadow newCalenderPill"
                    style={{
                      width:
                        showIcon && !isWeeklyNotification
                          ? "170px"
                          : "fit-content",
                      marginLeft: "2px",
                      height: "fit-content",
                      marginTop: id === 0 ? "56px" : "0px",
                      border: border,
                    }}
                  >
                    <div
                      className="header"
                      style={{
                        textDecorationLine: done ? "line-through" : "",
                      }}
                    >
                      {moment(occurance.occTS).format(
                        isWeeklyNotification ? "DD:MM" : "DD.MM.YYYY"
                      )}
                    </div>

                    {showIcon && !isWeeklyNotification && (
                      <TextIcon
                        style={{ display: "flex", alignItems: "center" }}
                        iconStyle={{ transform: "" }}
                        svg={icon}
                        text={iconText}
                        textColor={textColor}
                      />
                    )}
                  </div>
                ))
              );
            })}
          </td>
        ) : (
          // <td className={id % 2 == 0 ? 'brdr-none' : 'has-border'} style={{ height: id === 0 ? "136px" : "77px" }}>

          lane.occurance.map((occurance: any, k: any) => {
            let hasNotification = occurance?.notification !== undefined;

            let isClosed =
              hasNotification && occurance?.notification?.status === 2;
            let isTodayOrFuture =
              hasNotification &&
              isTodayOrFutureFnc(occurance?.notification?.dueuntil);

            let { icon, iconText, textColor, border } = RenderTileStyle(
              hasNotification,
              isClosed,
              isTodayOrFuture
            );

            return (
              occurance.occMonth == mon &&
              year == occurance.occYear &&
              (occurance?.notification?.nodeid != undefined ? (
                <Fragment key={k}>
                  <Link
                    to="/notification-details"
                    state={{
                      nodeid: occurance?.notification.nodeid,
                      equipmentNodeId: occurance?.notification.equipmentnodeid,
                      from: "maintenance_dashboard",
                    }}
                    onClick={() =>
                      handleNotificationClick(occurance?.notification)
                    }
                  >
                    <div
                      key={k}
                      className="bxShadow newCalenderPill"
                      style={{
                        width: showIcon ? "170px" : "fit-content",
                        height: "fit-content",
                        marginLeft: "2px",
                        marginTop:
                          id === 0 && boxCollapsed == mainIndex
                            ? "56px"
                            : "0px",

                        border: border,

                        margin:
                          boxCollapsed !== mainIndex
                            ? "0px 5px 5px 5px"
                            : "unset",
                      }}
                    >
                      <div
                        className="header"
                        style={{
                          textDecorationLine:
                            occurance?.notification.status === 2
                              ? "line-through"
                              : "",
                        }}
                      >
                        {moment(occurance.occTS).format(
                          isWeeklyNotification ? "DD:MM" : "DD.MM.YYYY"
                        )}
                      </div>
                      {showIcon ? (
                        <TextIcon
                          svg={icon}
                          text={iconText}
                          textColor={textColor}
                        />
                      ) : (
                        ""
                      )}{" "}
                    </div>
                  </Link>
                </Fragment>
              ) : (
                <>
                  <div
                    key={k}
                    className="bxShadow newCalenderPill"
                    style={{
                      width: showIcon ? "170px" : "fit-content",
                      marginLeft: "2px",
                      height: "fit-content",
                      marginTop: id === 0 ? "56px" : "0px",
                      border: border,
                      margin:
                        boxCollapsed !== mainIndex
                          ? "0px 5px 5px 5px"
                          : "unset",
                    }}
                  >
                    <div
                      className="header"
                      style={{
                        textDecorationLine: done ? "line-through" : "",
                      }}
                    >
                      {moment(occurance.occTS).format(
                        isWeeklyNotification ? "DD:MM" : "DD.MM.YYYY"
                      )}
                    </div>

                    {showIcon ? (
                      <TextIcon
                        style={{ display: "flex", alignItems: "center" }}
                        iconStyle={{ transform: "" }}
                        svg={icon}
                        text={iconText}
                        textColor={textColor}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </>
              ))
            );
          })
        )}
      </>
    );
  }

  const RenderTDMemo = React.memo(RenderTD);

  const handleMonths = (month: any, currMon: any) => {
    const months: any[] = [];
    for (var i = 0; i < month; i++) {
      let res = parseInt(currMon) + i;
      let j = 0;
      res > 12 * calenderTimeSpan ? (j = i - 12 * calenderTimeSpan) : (j = i);
      months.push((parseInt(currMon) + j).toString());
    }
    setCurrMonth(currMon);
    setMonthsById(months);
  };

  const handleArrowClick = (op: string) => {
    //RenderCalendar();
    let currentMon = +currMonth;
    handleMonths(3, op === "<" ? +currentMon - 1 : +currentMon + 1);
    setCurrMonth(op === "<" ? +currentMon - 1 : +currentMon + 1);
    setstopCalendar(+startCalendar);
  };

  const substring = (string: string, maxLength: number) => {
    return string.length > maxLength
      ? string.slice(0, maxLength) + "..."
      : string;
  };

  useEffect(() => {
    // onchange period dropdown
    const startingMonth = state.period;
    setstartCalendar(+startingMonth);
    handleMonths(+startingMonth, moment(new Date()).format("MM"));
    setstopCalendar(+startingMonth);
  }, [state.period]);

  useEffect(() => {
    if (stopCalendar !== undefined || monthsByID != undefined) {
    }
  }, [stopCalendar, monthsByID, getAllNotifications?.data, props.map]);

  useEffect(() => {
    handleMonths(stopCalendar, moment(new Date()).format("MM")); //by default 3

    setState({ ...state, ["period"]: "3" });
  }, []);

  return (
    <div className="sch" style={{ backgroundColor: "white" }}>
      <Grid container>
        <Grid item xs={6}>
          <div
            className="select-main"
            style={{ marginLeft: -35, justifyContent: "end" }}
          >
            <FormControl variant="standard" id="select1-main"></FormControl>
          </div>
        </Grid>
      </Grid>

      <div className="tableWrapper">
        <table id="table-main">
          <tbody>
            <tr>
              <th className="hideBorder"></th>
              {monthsByID.map((mon: any, i: any) => (
                <th
                  key={i}
                  className={monthsByID.length === i + 1 ? "hideBorder" : ""}
                  style={{ paddingTop: "8px", paddingBottom: "8px" }}
                >
                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent:
                        i === 0
                          ? "start"
                          : monthsByID.length === i + 1
                          ? "end"
                          : "center",
                    }}
                  >
                    {i === 0 && (
                      <div
                        className="monthLeftArrow"
                        style={{
                          display: +currMonth === 1 ? "none" : "block",
                        }}
                        onClick={() => {
                          handleArrowClick("<");
                        }}
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.30078 11.2998L0.700781 6.6998C0.600781 6.5998 0.530114 6.49147 0.488781 6.3748C0.446781 6.25814 0.425781 6.13314 0.425781 5.9998C0.425781 5.86647 0.446781 5.74147 0.488781 5.6248C0.530114 5.50814 0.600781 5.3998 0.700781 5.2998L5.30078 0.699804C5.48411 0.516471 5.71745 0.424805 6.00078 0.424805C6.28411 0.424805 6.51745 0.516471 6.70078 0.699804C6.88411 0.883138 6.97578 1.11647 6.97578 1.3998C6.97578 1.68314 6.88411 1.91647 6.70078 2.0998L2.80078 5.9998L6.70078 9.8998C6.88411 10.0831 6.97578 10.3165 6.97578 10.5998C6.97578 10.8831 6.88411 11.1165 6.70078 11.2998C6.51745 11.4831 6.28411 11.5748 6.00078 11.5748C5.71745 11.5748 5.48411 11.4831 5.30078 11.2998Z"
                            fill="black"
                            fillOpacity="0.5"
                          />
                        </svg>
                      </div>
                    )}

                    <div className={i === 0 ? "activeMonth" : "Month"}>
                      {monthsByName[(mon % 12 == 0 ? 12 : mon % 12) - 1]}{" "}
                      {moment()
                        .add(
                          mon <= 12
                            ? 0
                            : mon % 12 == 0
                            ? mon / 12 - 1
                            : mon / 12,
                          "y"
                        )
                        .format("YYYY")}
                    </div>
                    {monthsByID.length === i + 1 && (
                      <div
                        className="monthRightArrow"
                        onClick={() => {
                          handleArrowClick(">");
                        }}
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0.700781 11.2998C0.517448 11.1165 0.425781 10.8831 0.425781 10.5998C0.425781 10.3165 0.517448 10.0831 0.700781 9.8998L4.60078 5.9998L0.700781 2.0998C0.517448 1.91647 0.425781 1.68314 0.425781 1.3998C0.425781 1.11647 0.517448 0.883138 0.700781 0.699804C0.884114 0.516471 1.11745 0.424805 1.40078 0.424805C1.68411 0.424805 1.91745 0.516471 2.10078 0.699804L6.70078 5.2998C6.80078 5.3998 6.87178 5.50814 6.91378 5.6248C6.95511 5.74147 6.97578 5.86647 6.97578 5.9998C6.97578 6.13314 6.95511 6.25814 6.91378 6.3748C6.87178 6.49147 6.80078 6.5998 6.70078 6.6998L2.10078 11.2998C1.91745 11.4831 1.68411 11.5748 1.40078 11.5748C1.11745 11.5748 0.884114 11.4831 0.700781 11.2998Z"
                            fill="black"
                            fillOpacity="0.5"
                          />
                        </svg>
                      </div>
                    )}
                  </div>
                </th>
              ))}
            </tr>

            {map &&
              Object.values(map).map((item: any, index: any) => {
                return (
                  <tr key={index}>
                    <td className="boxCollapsedTd">
                      <div
                        className="boxCollapsedWrapper"
                        style={{
                          borderRadius:
                            boxCollapsed === index
                              ? "4px 4px 0px 0px"
                              : "4px 4px 4px 4px",
                        }}
                      >
                        <ListItem
                          button
                          onClick={() =>
                            setBoxCollapsed(boxCollapsed === index ? -1 : index)
                          }
                          className="boxCollapsed"
                        >
                          <div className="header">
                            <div className="title">{item.name}</div>
                            <div className="description">
                              {substring(item.brand + "/" + item.model, 30)}
                            </div>
                          </div>
                          <div className="icon">
                            {boxCollapsed === index ? (
                              <ExpandLess />
                            ) : (
                              <ExpandMore />
                            )}
                          </div>
                        </ListItem>
                        <Collapse
                          in={boxCollapsed === index}
                          timeout="auto"
                          unmountOnExit
                        >
                          {item.swimLanes.map((swim: any, index: any) => {
                            return (
                              <div className="collapseCard" key={index}>
                                <div className="collapseCardtitle1">
                                  {
                                    swim.task.hascategory[0]
                                      ?.maintenancecategory.name
                                  }
                                </div>
                                <Tooltip title={swim.task.title}>
                                  <div className="collapseCardtitle2">
                                    {substring(swim.task.title, 33)}
                                  </div>
                                </Tooltip>
                                <div className="collapseCardIconSet">
                                  <TextIcon
                                    svg={
                                      <svg
                                        width="14"
                                        height="16"
                                        viewBox="0 0 14 16"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M12.666 14.1667H10.666C10.4771 14.1667 10.3188 14.1028 10.191 13.975C10.0632 13.8473 9.99935 13.6889 9.99935 13.5C9.99935 13.3112 10.0632 13.1528 10.191 13.025C10.3188 12.8973 10.4771 12.8334 10.666 12.8334H12.666V6.16671H3.33268V8.16671C3.33268 8.3556 3.26879 8.51393 3.14102 8.64171C3.01324 8.76949 2.8549 8.83337 2.66602 8.83337C2.47713 8.83337 2.31879 8.76949 2.19102 8.64171C2.06324 8.51393 1.99935 8.3556 1.99935 8.16671V3.50004C1.99935 3.13337 2.1299 2.81949 2.39102 2.55837C2.65213 2.29726 2.96602 2.16671 3.33268 2.16671H3.99935V1.50004C3.99935 1.31115 4.06324 1.15282 4.19102 1.02504C4.31879 0.897263 4.47713 0.833374 4.66602 0.833374C4.8549 0.833374 5.01324 0.897263 5.14102 1.02504C5.26879 1.15282 5.33268 1.31115 5.33268 1.50004V2.16671H10.666V1.50004C10.666 1.31115 10.7299 1.15282 10.8577 1.02504C10.9855 0.897263 11.1438 0.833374 11.3327 0.833374C11.5216 0.833374 11.6799 0.897263 11.8077 1.02504C11.9355 1.15282 11.9993 1.31115 11.9993 1.50004V2.16671H12.666C13.0327 2.16671 13.3466 2.29726 13.6077 2.55837C13.8688 2.81949 13.9993 3.13337 13.9993 3.50004V12.8334C13.9993 13.2 13.8688 13.5139 13.6077 13.775C13.3466 14.0362 13.0327 14.1667 12.666 14.1667ZM6.11602 12.8334H1.33268C1.14379 12.8334 0.98546 12.7695 0.857682 12.6417C0.729905 12.5139 0.666016 12.3556 0.666016 12.1667C0.666016 11.9778 0.729905 11.8195 0.857682 11.6917C0.98546 11.5639 1.14379 11.5 1.33268 11.5H6.11602L4.86602 10.2334C4.74379 10.1112 4.6799 9.95837 4.67435 9.77504C4.66879 9.59171 4.73268 9.43337 4.86602 9.30004C4.98824 9.17782 5.14379 9.11671 5.33268 9.11671C5.52157 9.11671 5.67713 9.17782 5.79935 9.30004L8.19935 11.7C8.33268 11.8334 8.39935 11.9889 8.39935 12.1667C8.39935 12.3445 8.33268 12.5 8.19935 12.6334L5.79935 15.0334C5.67713 15.1556 5.52435 15.2195 5.34102 15.225C5.15768 15.2306 4.99935 15.1667 4.86602 15.0334C4.74379 14.9112 4.68268 14.7556 4.68268 14.5667C4.68268 14.3778 4.74379 14.2223 4.86602 14.1L6.11602 12.8334ZM3.33268 4.83337H12.666V3.50004H3.33268V4.83337Z"
                                          fill="black"
                                          fillOpacity="0.5"
                                        />
                                      </svg>
                                    }
                                    text={moment(
                                      swim?.task?.startingfrom
                                    ).format("DD.MM.YYYY")}
                                  />
                                  <TextIcon
                                    svg={
                                      <svg
                                        width="16"
                                        height="11"
                                        viewBox="0 0 16 11"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.03255 10.8333C6.54366 10.8333 5.277 10.3166 4.23255 9.28329C3.18811 8.24996 2.66589 6.98885 2.66589 5.49996V5.38329L2.06589 5.98329C1.94366 6.10552 1.78811 6.16663 1.59922 6.16663C1.41033 6.16663 1.25477 6.10552 1.13255 5.98329C1.01033 5.86107 0.949219 5.70551 0.949219 5.51663C0.949219 5.32774 1.01033 5.17218 1.13255 5.04996L2.86589 3.31663C2.93255 3.24996 3.00477 3.20263 3.08255 3.17463C3.16033 3.14707 3.24366 3.13329 3.33255 3.13329C3.42144 3.13329 3.50477 3.14707 3.58255 3.17463C3.66033 3.20263 3.73255 3.24996 3.79922 3.31663L5.53255 5.04996C5.65477 5.17218 5.71589 5.32774 5.71589 5.51663C5.71589 5.70551 5.65477 5.86107 5.53255 5.98329C5.41033 6.10552 5.25477 6.16663 5.06589 6.16663C4.877 6.16663 4.72144 6.10552 4.59922 5.98329L3.99922 5.38329V5.49996C3.99922 6.61107 4.391 7.55551 5.17455 8.33329C5.95766 9.11107 6.91033 9.49996 8.03255 9.49996C8.25477 9.49996 8.47144 9.48063 8.68255 9.44196C8.89366 9.40285 9.10477 9.3444 9.31589 9.26663C9.427 9.22218 9.54655 9.21107 9.67455 9.23329C9.80211 9.25551 9.91033 9.31107 9.99922 9.39996C10.1992 9.59996 10.2799 9.81374 10.2412 10.0413C10.2021 10.2693 10.0548 10.4277 9.79922 10.5166C9.51033 10.6166 9.21877 10.6944 8.92455 10.75C8.62989 10.8055 8.33255 10.8333 8.03255 10.8333ZM12.6659 7.86663C12.577 7.86663 12.4937 7.85263 12.4159 7.82463C12.3381 7.79707 12.2659 7.74996 12.1992 7.68329L10.4659 5.94996C10.3437 5.82774 10.2826 5.67218 10.2826 5.48329C10.2826 5.2944 10.3437 5.13885 10.4659 5.01663C10.5881 4.8944 10.7437 4.83329 10.9326 4.83329C11.1214 4.83329 11.277 4.8944 11.3992 5.01663L11.9992 5.61663V5.49996C11.9992 4.38885 11.6077 3.4444 10.8246 2.66663C10.041 1.88885 9.08811 1.49996 7.96589 1.49996C7.74366 1.49996 7.527 1.51951 7.31589 1.55863C7.10477 1.59729 6.89366 1.65551 6.68255 1.73329C6.57144 1.77774 6.45211 1.78885 6.32455 1.76663C6.19655 1.7444 6.08811 1.68885 5.99922 1.59996C5.79922 1.39996 5.71855 1.18596 5.75722 0.957959C5.79633 0.730404 5.94366 0.572181 6.19922 0.483293C6.48811 0.383293 6.77989 0.305515 7.07455 0.249959C7.36877 0.194404 7.66589 0.166626 7.96589 0.166626C9.45477 0.166626 10.7214 0.683293 11.7659 1.71663C12.8103 2.74996 13.3326 4.01107 13.3326 5.49996V5.61663L13.9326 5.01663C14.0548 4.8944 14.2103 4.83329 14.3992 4.83329C14.5881 4.83329 14.7437 4.8944 14.8659 5.01663C14.9881 5.13885 15.0492 5.2944 15.0492 5.48329C15.0492 5.67218 14.9881 5.82774 14.8659 5.94996L13.1326 7.68329C13.0659 7.74996 12.9937 7.79707 12.9159 7.82463C12.8381 7.85263 12.7548 7.86663 12.6659 7.86663Z"
                                          fill="black"
                                          fillOpacity="0.5"
                                        />
                                      </svg>
                                    }
                                    text={
                                      swim.task.repetitioninterval === "1w"
                                        ? "1 woche"
                                        : swim.task.repetitioninterval === "1m"
                                        ? "monatlich"
                                        : swim.task.repetitioninterval === "3m"
                                        ? "quartalsweise"
                                        : swim.task.repetitioninterval ===
                                          "onetime"
                                        ? "einmalig"
                                        : swim.task.repetitioninterval === "6m"
                                        ? "6 monats"
                                        : swim.task.repetitioninterval === "1y"
                                        ? "jährlich"
                                        : swim.task.repetitioninterval === "18m"
                                        ? "18 monats"
                                        : "24 monats"
                                    }
                                  />
                                </div>
                              </div>
                            );
                          })}
                        </Collapse>
                      </div>
                    </td>
                    {monthsByID.map(
                      (
                        mon: any,
                        i: any // render <td>s w.r.t month
                      ) => (
                        <td
                          key={i}
                          style={{
                            verticalAlign: "top",
                            padding: 0,
                            margin: 0,
                            borderBottom: "none",
                          }}
                        >
                          <table
                            className="cstm-table"
                            style={{
                              marginTop:
                                boxCollapsed !== index ? "12px" : "0px",
                            }}
                          >
                            <tbody
                              style={{
                                display:
                                  boxCollapsed !== index
                                    ? "flex"
                                    : "table-row-group",
                                flexWrap: "wrap",
                                width:
                                  boxCollapsed !== index ? "194px" : "100%",
                              }}
                            >
                              {item.swimLanes.map((lane: any, j: any) => (
                                <>
                                  {
                                    <Zoom in={true} timeout={1000}>
                                      <tr key={j} className="swimLane-tr">
                                        <RenderTDMemo
                                          mainIndex={index}
                                          lane={lane}
                                          id={j}
                                          mon={mon % 12 == 0 ? 12 : mon % 12}
                                          year={moment()
                                            .add(
                                              +mon <= 12
                                                ? 0
                                                : +mon % 12 == 0
                                                ? +mon / 12 - 1
                                                : +mon / 12,
                                              "y"
                                            )
                                            .format("YYYY")}
                                          showIcon={boxCollapsed === index}
                                        />
                                      </tr>
                                    </Zoom>
                                  }
                                </>
                              ))}
                            </tbody>
                          </table>
                        </td>
                      )
                    )}
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default NewCalender;
